import { MissionType } from './mission';

export const enum CopyType {
  SPACE = 1, // 世界观
  STORY = 2, // 故事
  BOT = 3, // 角色
  SCENE = 4, // 幕
  MISSION = 5, // 剧情
  PROPS = 6, // 道具卡
  PROMOTION = 7, // 首页配置
}

export const enum StorageType {
  SPACE = 'space',
  STORY = 'story',
  BOT = 'bot',
  SCENE = 'scene',
  MISSION = 'mission',
  PROPS = 'props',
  PROMOTION = 'promotion',
  TEMPLATE = 'template'
}

export const enum SortType {
  SPACE = 1,
  STORY = 2,
  BOT = 3,
  SCENE = 4,
  MISSION = 5,
  MISSION_TYPE_MAINLINE = 6, // 主线任务
  MISSION_TYPE_SUCCESS = 7, // 成功任务
  MISSION_TYPE_FAILURE = 8, // 失败任务
  MISSION_TYPE_PROLOGUE = 9, // 开场白
  ITEM_CARD = 10, // 道具卡

  PROMOTION = 11, // 首页配置
  PLAZA = 12
}

export const MissionSortMap = {
  [MissionType.MISSION_TYPE_PROLOGUE]: SortType.MISSION_TYPE_PROLOGUE,
  [MissionType.MISSION_TYPE_MAINLINE]: SortType.MISSION_TYPE_MAINLINE,
  [MissionType.MISSION_TYPE_SUCCESS]: SortType.MISSION_TYPE_SUCCESS,
  [MissionType.MISSION_TYPE_FAILURE]: SortType.MISSION_TYPE_FAILURE,
};

export const CAN_SEARCH = true; // 开启搜索

export const CAN_SORT = true; // 开启排序

export const CAN_COPY = true; // 开启复制

export const BOT_CAI = true; // 开启CAI

// 控制lit渲染
export const formLitRender = (judge: boolean, key: string) => (judge ? key : 'hidden');
